import { AccessGrant, config } from '@mybonus/public';
import { useAuthContext, useAPI, useClientStorage, useToastsContext } from '@mybonus/ui';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export function useExtensionAuthHandover() {
	const auth = useAuthContext();
	const [searchParams] = useSearchParams();
	const { api } = useAPI();
	const accessGrantStorage = useClientStorage<AccessGrant>({
		key: config.storage.keys.accessGrantTmp,
		type: 'session',
	});
	const toasts = useToastsContext();

	useEffect(() => {
		if (!auth.account || !searchParams.has('exth')) {
			return;
		}

		api.guest.auth.token.cloneToExt
			.mutate({ platformAlias: 'EXT_CHROME' })
			.then((accessGrant) => {
				accessGrantStorage.setItem(accessGrant);
			})
			.catch(() => {
				toasts.addToast({
					type: 'error',
					message: 'Kunde inte logga in pluginet.',
					details: 'Försök igen lite senare, eller kontakta kundtjänst om problemet kvarstår.',
					timeout: 'never',
				});
			});
	}, [auth.account]);
}
